import { createContext } from 'react';
import { simulationResultManagerStore } from '@/newcar/core/store/simulationResultManagerStore';

const SimulationResultManagerStoreContext = createContext(simulationResultManagerStore);

export default SimulationResultManagerStoreContext;
